module.exports = __webpack_public_path__ + "static/media/pitch-mock-7.b270a38c.png";